<template>
  <el-table-column
    prop="creator_user_name"
    label="Rögzítette"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.creator_user_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'creator_user_name',
  };
</script>
